import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable } from '@angular/material/table';
import { IHelpImpactElement } from 'src/app/core/models/front';
import { IHelpDataService } from 'src/app/core/services/core';

@Component({
  selector: 'howden-help-impact',
  templateUrl: './help-impact.component.html',
  styleUrls: ['./help-impact.component.scss'],
  imports: [
    CdkScrollable,
    MatDialogTitle,
    MatDialogContent,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ]
})
export class HelpImpactComponent {
  private helpDataSrv = inject(IHelpDataService);

  public dataSource: IHelpImpactElement[] = [];
  public displayedColumns: string[] = ['clasification', 'value', 'quantification'];

  constructor() {
    this.dataSource = this.helpDataSrv.getDataHelpImpact();
  }
}
